import { SkeletonRect, Stack, Text } from '@ekhodealer/ekho-common/rev';

const DOCUMENT_SECTION_TITLES = [
	'Buyer identification documents',
	'Sale documents',
	'Financing & insurance contracts',
	'Titling and registration documents',
] as const;

/**
 * Skeleton component for the Documents tab content.
 * Matches the section titles and layout of DocumentsTabContent; content under each heading is a single skeleton rect.
 */
export const DocumentsSkeleton = () => {
	return (
		<Stack itemsSpacing='24' padding={{ top: '12' }}>
			{DOCUMENT_SECTION_TITLES.map((title) => (
				<Stack key={title} itemsSpacing='16'>
					<Text size='body' weight='semibold'>
						{title}
					</Text>
					<SkeletonRect width='100%' height={80} />
				</Stack>
			))}
		</Stack>
	);
};
